<template>
  <v-container
    v-if="clients"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      align-center
    >
      <v-flex xs12>
        <material-card
          color="green"
          title="New Assessment"
        >
          <v-card-text>
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-form>
                  <v-select
                    id="selectClientId"
                    v-model="clientId"
                    item-text="name"
                    item-value="id"
                    :items="clients"
                    label="Client"
                  />
                  <v-text-field
                    id="assessmentName"
                    v-model="name"
                    name="Name"
                    label="Assessment Name"
                  />
                  <v-select
                    v-model="frequency"
                    :items="frequencies"
                    label="Frequency"
                  />
                  <v-btn
                    id="buttonStartAssessment"
                    color="success"
                    @click="start"
                  >
                    Start Assessment
                  </v-btn>
                </v-form>
              </v-flex>
            </v-layout>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>

    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      />
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data: () => ({
    clientId: null,
    frequencies: ['Monthly', 'Quarterly', 'Annual'],
    frequency: undefined,
    name: '',
  }),
  computed: {
    ...mapGetters('odata', ['clients']),
  },
  mounted() {
    this.$store.dispatch('odata/load.clients');
  },
  methods: {
    ...mapActions('assessments', ['startAssessment']),
    start() {
      this.startAssessment({
        clientId: this.clientId,
        createdBy: this.$auth.authentication.userName,
        frequency: this.frequency,
        name: this.name,
      }).then((assessment) => {
        this.$router.push({ name: 'Edit Assessment', params: { id: assessment.id } });
      });
    },
  },
};
</script>
